export const aboutUsData =  [
  {
    id: 'facebook_ad',
    name: 'Social Media',
    value: 'facebook ad', 
  },
  {
    id: 'referral',
    name: 'Referral - Business',
    value: 'referral - business', 
  },
  {
    id: 'referral_family',
    name: 'Referral - Family/Friend',
    value: 'referral - family/Friend', 
  },
  {
    id: 'yard_sign',
    name: 'Yard Sign',
    value: 'yard sign', 
  },
  {
    id: 'search_engine',
    name: 'Search Engine',
    value: 'search engine', 
  },
  {
    id: 'truck',
    name: 'Truck',
    value: 'truck', 
  },
  // {
  //   id: 'advertisement',
  //   name: 'Advertisement',
  //   value: 'advertisement',
  // },
  {
    id: 'direct_mail',
    name: 'Direct Mail',
    value: 'direct mail', 
  },
  {
    id: 'show_or_event',
    name: 'Trade Show or Event',
    value: 'trade show or event', 
  },
  {
    id: 'billboard',
    name: 'Billboard',
    value: 'billboard', 
  },
  {
    id: 'video_advertisement',
    name: 'Video Advertisement',
    value: 'video advertisement', 
  },
  {
    id: 'door_hanger',
    name: 'Door Hanger',
    value: 'door hanger', 
  },
  {
    id: 'other',
    name: 'Other',
    value: 'other', 
  }
];
